define('w3c/rfc2119',["exports", "core/utils"], function (exports, _utils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  const name = exports.name = "w3c/rfc2119"; // Module w3c/rfc2119
  // update the 2119 terms section with the terms actually used

  function run(conf, doc, cb) {
    const confo = doc.getElementById("respecRFC2119");
    if (!confo) {
      return cb();
    }
    // do we have a list of used RFC2119 items in
    // conf.respecRFC2119
    const terms = Object.getOwnPropertyNames(conf.respecRFC2119);

    // there are no terms used - remove the clause
    if (terms.length === 0) {
      confo.remove();
      return cb();
    }

    // put in the 2119 clause and reference
    const html = (0, _utils.joinAnd)(terms.sort(), item => `<em class="rfc2119">${item}</em>`);
    const plural = terms.length > 1;
    const str = `The key word${plural ? "s " : " "} ${html} ${plural ? "are" : "is"} ${confo.innerHTML}`;
    confo.innerHTML = str;
    cb();
  }
});
//# sourceMappingURL=rfc2119.js.map;
